import React, { Component } from "react";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("خطای React:", error, errorInfo); // خطا همچنان در کنسول نمایش داده می‌شود
    }

    render() {
        if (this.state.hasError) {
            return null; // از نمایش خطا روی صفحه جلوگیری می‌کند
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
